import {InjectionToken, Signal} from '@angular/core';
import {Observable} from 'rxjs';

export interface ErrorProvider {
  customError: {
    code: Signal<string>;
    message$: Observable<string | null>;
  };
}

export const ErrorToken = new InjectionToken<ErrorProvider>('Error');
